import { defaultTheme } from 'evergreen-ui';
import { cloneDeep } from 'lodash';

const refTheme = cloneDeep(defaultTheme);
export { refTheme };
